import axios from 'axios';
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

import { 
  CREATE_ENQUIRY_FORM, 
  UPDATE_ENQUIRY_FORM,
  ACTIVATE_ENQUIRY_FORM,
  DEACTIVATE_ENQUIRY_FORM,
  LIST_ENQUIRY_FORMS,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';

export default {
  name: 'ManageForms',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    AICampusFooter,
    NavigationBackButton
  },
  data:() => ({
      question_forms: [],
      enquiry_form_name: '',
      enquiry_form_description: '',
      update_enquiry_form_name: '',
      update_enquiry_form_description: '',
      enquiry_form_id:'',
      headers: get_headers(),
      token: get_token(),
      project_id: get_project_id(),
      active_enquiry_count: 0,
  }),
  mounted() {
    this.fetch_enquiry_forms();
  },
  computed: {
    active_enquiries_count() {
      this.active_enquiry_count = this.question_forms.filter(form => form.Status === 'Active').length;
      return this.active_enquiry_count;
    }
  },
  methods: {
    assign_questions_to_form(enquiry_form_id, form_name) {
      sessionStorage.setItem('enquiry_form_id', enquiry_form_id);
      sessionStorage.setItem('form_name', form_name);
      this.$router.push({
        path: '/assign_questions_to_enquiry_form',
        query: { enquiry_form_id: enquiry_form_id, form_name: form_name }
      });
    },

    fetch_enquiry_forms() {
      axios.get(LIST_ENQUIRY_FORMS, {
        headers: this.headers,
        params: { project_id: this.project_id }
      })
        .then(response => {
          if (response.data.status === 'success') {
            this.question_forms = response.data.data.map(form => ({
              ID: form.id,
              "Form Name": form.title,
              "Form Description": form.description,
              Status: form.is_active ? 'Active' : 'Inactive',
              "Date Created": this.format_date(form.created_at),
              "Data Updated": this.format_date(form.updated_at)
            }));
          } else {
            this.show_error('Failed to load enquiry forms');
          }
        })
        .catch(error => {
          this.show_error(`Error fetching forms: ${error.response?.data?.message}`);
        });
    }
,    

    async create_enquiry_form() {
      const payload = {
        title: this.enquiry_form_name,
        description: this.enquiry_form_description,
        is_active: true,
        project_id:this.project_id

      };
      try {
        const response = await axios.post(CREATE_ENQUIRY_FORM, payload, { headers: this.headers });
        const response_data = response.data;

        if (response_data.status === 'success') { 
          this.show_success('Enquiry form created successfully');
          this.close_modal('create_enquiry_form');
          window.location.reload();
        } else {
          this.show_error('Error during workflow creation');
          this.close_modal('create_enquiry_form');
          window.location.reload();
        }
      } catch (error) {
        this.show_error(`Error creating workflow: ${error.response?.data?.message}`);
      } 
    },


    open_edit_modal(form) {
      this.enquiry_form_id = form.ID;
      this.update_enquiry_form_name = form["Form Name"];
      this.update_enquiry_form_description = form["Form Description"];
    },


    async edit_enquiry_form() {

      const payload = {
        title: this.update_enquiry_form_name,
        description: this.update_enquiry_form_description,
        is_active: true,
        enquiry_form_id: this.enquiry_form_id
      };
  
      try {
        const response = await axios.post(UPDATE_ENQUIRY_FORM, payload, { headers: this.headers });
        const response_data = response.data;
  
        if (response_data.status === 'success') { 
          this.show_success('Enquiry form updated successfully');
          this.close_modal('edit_enquiry_form');
          this.fetch_enquiry_forms(); // Refresh the list
        } else {
          this.show_error('Error during form update');
        }
      } catch (error) {
        this.show_error(`Error updating form: ${error.response?.data?.message}`);
      }
    },

    async deactivate_enquiry_form(enquiry_form_id) {
      const payload = {
        is_active: false,
        enquiry_form_id: enquiry_form_id
      };
  
      try {
        await axios.post(DEACTIVATE_ENQUIRY_FORM, payload, { headers: this.headers });
        window.location.reload();
      } catch (error) {
        this.show_error(`Error deactivating form: ${error.response?.data?.message}`);
      }
    },

    async activate_enquiry_form(enquiry_form_id) {
      const payload = {
        is_active: true,
        enquiry_form_id: enquiry_form_id,
        project_id:this.project_id
      };
  
      try {
        await axios.post(ACTIVATE_ENQUIRY_FORM, payload, { headers: this.headers });
        window.location.reload();
      } catch (error) {
        this.show_error(`Error activating form: ${error.response?.data?.message}`);
      }
    },
    
  }
};
